import React from 'react'
import {Icon, Header, Loader} from "semantic-ui-react";
import '../style.css'
import {NavLink} from "react-router-dom";


function Navbar(
    {
        loginUser,
        userName,
        loginStatus,
        loading,
        logoutUser
    }
) {

    return (
        <>
            <nav>
                <ul
                    className='navbarStyle'
                    widths={9}
                >
                    <li>
                        <NavLink activeclassname='active' exact to='/'>Home</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/pronunciation'>Pronunciation</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/dialogConversation'>Dialog</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/translation'>Translation Flash Cards</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/dialogFlashCard'>Dialog Flash Cards</NavLink>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/quizzes'>Translation Practice</NavLink>
                    </li>
                    <li>
                        <a activeclassname='active'
                           onClick={() => window.open('http://www2.hawaii.edu/%7Eleighj/SAMOAN/dictionary/')}>Dictionary</a>
                    </li>
                    <li>
                        <NavLink activeclassname='active' to='/admin'><Icon name='edit'></Icon></NavLink>
                    </li>
                    {
                        loading ?
                            <li>
                                <a><Loader size='mini' active inline/></a>
                            </li>
                            :
                            loginStatus ?
                                <>
                                    <li>
                                        <a onClick={logoutUser}>
                                        <Header style={{color: 'white'}} as='h5'>Logged in
                                            as {userName}</Header>
                                        </a>
                                    </li>
                                </>

                                :

                                <li>
                                    <a onClick={loginUser}><Icon name='user'></Icon>Login</a>
                                </li>
                    }

                </ul>
            </nav>

            {/*<Menu color='blue' inverted>*/}
            {/*    <Menu.Item*/}
            {/*        name='home'*/}
            {/*        style={this.props.state.activeItem === '/' || activeItem ==='home' ? {backgroundColor: '#00bed2'}:null}*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink exact to='/'>Home</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='pronunciation'*/}
            {/*        style={this.props.state.activeItem === '/pronunciation' || activeItem === 'pronunciation'? {backgroundColor: '#00bed2'}:null}*/}
            {/*        link*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink to='/pronunciation'>PronunciationWrapper</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='dialogConversation'*/}
            {/*        style={this.props.state.activeItem === '/dialogConversation' || activeItem === 'dialogConversation' ? {backgroundColor: '#00bed2'}:null}*/}
            {/*        link*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink to='/dialogConversation'>Dialog</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='translation'*/}
            {/*        style={this.props.state.activeItem === '/translation' || activeItem === 'translation' ? {backgroundColor: '#00bed2'}:null}*/}
            {/*        link*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink to='/translation'>Translation Flash Cards</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='dialogFlashCard'*/}
            {/*        style={this.props.state.activeItem === '/dialogFlashCard' || activeItem === 'dialogFlashCard' ? {backgroundColor: '#00bed2'}:null}*/}
            {/*        link*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink to='/dialogFlashCard'>Dialog Flash Cards</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='quizzes'*/}
            {/*        style={this.props.state.activeItem === '/quizzes' || activeItem === 'quizzes' ? {backgroundColor: '#00bed2'}:null}*/}
            {/*        link*/}
            {/*        onClick={this.props.handleItemClick}*/}
            {/*    >*/}
            {/*        <NavLink to='/quizzes'>Translation Practice</NavLink>*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='dictionary'*/}
            {/*        active={activeItem === 'dictionary'}*/}
            {/*        link*/}
            {/*        href='http://www2.hawaii.edu/%7Eleighj/SAMOAN/dictionary/'*/}
            {/*        target='_blank'*/}
            {/*        position='right'*/}
            {/*    >*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='Login'*/}
            {/*    >*/}
            {/*    </Menu.Item>*/}
            {/*    <Menu.Item*/}
            {/*        name='Edit Pages'*/}
            {/*    >*/}
            {/*    </Menu.Item>*/}
            {/*</Menu>*/}
        </>
    )

}

export default Navbar
